<h1>Reports</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link *ngFor="let tab of tabs | visibleFinanceTabs" (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
    {{tab.title}}
  </a>
</nav>

<div class="report-card statements-panel">
  <h3>Financial Statements</h3>
  <div class="report-controls statements-controls">
    <div class="statements-row">
      <mat-form-field appearance="fill">
        <mat-label>Date Range</mat-label>
        <mat-select [(ngModel)]="statementPreset" (selectionChange)="onRangePresetChange()">
          <mat-option *ngFor="let option of rangePresetOptions" [value]="option.value">
            {{option.label}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Period Start</mat-label>
        <input matInput type="date" [(ngModel)]="statementStartDate" (ngModelChange)="onCustomDateChanged()">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Period End</mat-label>
        <input matInput type="date" [(ngModel)]="statementEndDate" (ngModelChange)="onCustomDateChanged()">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Statement Set</mat-label>
        <mat-select [(ngModel)]="statementScope">
          <mat-option value="both">P&amp;L + Balance Sheet</mat-option>
          <mat-option value="profit-loss">Profit &amp; Loss Only</mat-option>
          <mat-option value="balance-sheet">Balance Sheet Only</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="statements-row">
      <mat-form-field appearance="fill">
        <mat-label>Min Absolute Amount</mat-label>
        <input matInput type="number" min="0" step="0.01" [(ngModel)]="minimumAbsAmount">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Account Search</mat-label>
        <input matInput [(ngModel)]="accountSearchTerm" placeholder="Code or name">
      </mat-form-field>

      <mat-slide-toggle [(ngModel)]="includeZeroLines">Include Zero Lines</mat-slide-toggle>

      <button mat-raised-button color="primary" (click)="loadFinancialStatements()">Run Statements</button>
    </div>
  </div>
</div>

<div class="custom-reports-panel">
  <h4>Custom Reports</h4>
  <div class="report-controls custom-reports-controls">
    <mat-form-field appearance="fill">
      <mat-label>Custom Report Name</mat-label>
      <input matInput [(ngModel)]="customReportName" placeholder="Quarterly board pack">
    </mat-form-field>

    <div class="actions">
      <button mat-stroked-button color="primary" (click)="saveCustomReport()">Save as New</button>
      <button mat-stroked-button (click)="updateSelectedCustomReport()" [disabled]="!selectedCustomReportId">Update Selected</button>
    </div>
  </div>

  <div class="report-controls custom-reports-controls">
    <mat-form-field appearance="fill">
      <mat-label>Saved Custom Reports</mat-label>
      <mat-select [(ngModel)]="selectedCustomReportId">
        <mat-option *ngFor="let customReport of customReports" [value]="customReport.id">
          {{customReport.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="actions">
      <button mat-stroked-button (click)="applySelectedCustomReport()">Apply Saved</button>
      <button mat-stroked-button color="warn" (click)="deleteSelectedCustomReport()">Delete Saved</button>
    </div>
  </div>
</div>

<div class="statement-grid" *ngIf="profitLoss || balanceSheet">
  <div class="report-card" *ngIf="profitLoss && shouldShowProfitLoss()">
    <div class="report-card-header">
      <h3>Profit &amp; Loss</h3>
      <button mat-stroked-button (click)="downloadProfitLossCsv()">Download CSV</button>
    </div>
    <p><strong>Period:</strong> {{statementStartDate | date:'mediumDate'}} - {{statementEndDate | date:'mediumDate'}}</p>

    <table class="statement-table">
      <thead>
      <tr>
        <th>Account</th>
        <th class="amount">Amount</th>
      </tr>
      </thead>
      <tbody>
      <tr class="section">
        <td colspan="2">Revenue</td>
      </tr>
      <tr *ngFor="let line of profitLoss.revenueLines">
        <td>{{line.accountCode}} {{line.accountName}}</td>
        <td class="amount">{{line.amount | number:'1.2-2'}}</td>
      </tr>
      <tr class="total">
        <td>Total Revenue</td>
        <td class="amount">{{profitLoss.totalRevenue | number:'1.2-2'}}</td>
      </tr>

      <tr class="section">
        <td colspan="2">Expenses</td>
      </tr>
      <tr *ngFor="let line of profitLoss.expenseLines">
        <td>{{line.accountCode}} {{line.accountName}}</td>
        <td class="amount">{{line.amount | number:'1.2-2'}}</td>
      </tr>
      <tr class="total">
        <td>Total Expenses</td>
        <td class="amount">{{profitLoss.totalExpenses | number:'1.2-2'}}</td>
      </tr>

      <tr class="net">
        <td>Net Income</td>
        <td class="amount">{{profitLoss.netIncome | number:'1.2-2'}}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="report-card" *ngIf="balanceSheet && shouldShowBalanceSheet()">
    <div class="report-card-header">
      <h3>Balance Sheet</h3>
      <button mat-stroked-button (click)="downloadBalanceSheetCsv()">Download CSV</button>
    </div>
    <p><strong>As Of:</strong> {{statementEndDate | date:'mediumDate'}}</p>

    <table class="statement-table">
      <thead>
      <tr>
        <th>Account</th>
        <th class="amount">Amount</th>
      </tr>
      </thead>
      <tbody>
      <tr class="section">
        <td colspan="2">Assets</td>
      </tr>
      <tr *ngFor="let line of balanceSheet.assetLines">
        <td>{{line.accountCode}} {{line.accountName}}</td>
        <td class="amount">{{line.amount | number:'1.2-2'}}</td>
      </tr>
      <tr class="total">
        <td>Total Assets</td>
        <td class="amount">{{balanceSheet.totalAssets | number:'1.2-2'}}</td>
      </tr>

      <tr class="section">
        <td colspan="2">Liabilities</td>
      </tr>
      <tr *ngFor="let line of balanceSheet.liabilityLines">
        <td>{{line.accountCode}} {{line.accountName}}</td>
        <td class="amount">{{line.amount | number:'1.2-2'}}</td>
      </tr>
      <tr class="total">
        <td>Total Liabilities</td>
        <td class="amount">{{balanceSheet.totalLiabilities | number:'1.2-2'}}</td>
      </tr>

      <tr class="total">
        <td>Current Earnings</td>
        <td class="amount">{{balanceSheet.currentEarnings | number:'1.2-2'}}</td>
      </tr>

      <tr class="net">
        <td>Total Liabilities + Equity</td>
        <td class="amount">{{balanceSheet.totalLiabilitiesAndEquity | number:'1.2-2'}}</td>
      </tr>

      <tr class="imbalance" [class.ok]="balanceSheet.isBalanced">
        <td>Balance Check (Assets - Liabilities - Equity)</td>
        <td class="amount">{{balanceSheet.imbalance | number:'1.2-2'}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="report-card" *ngIf="outstandingBalances">
  <div class="report-card-header">
    <h3>Outstanding A/P and A/R</h3>
    <button mat-stroked-button (click)="downloadOutstandingBalancesCsv()">Download CSV</button>
  </div>
  <p><strong>As Of:</strong> {{outstandingBalances.asOfDate | date:'mediumDate'}}</p>

  <div class="statement-grid">
    <div>
      <h4>Accounts Receivable</h4>
      <table class="statement-table">
        <thead>
        <tr>
          <th>Account</th>
          <th class="amount">Amount</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let line of outstandingBalances.receivableLines">
          <td>{{line.accountCode}} {{line.accountName}}</td>
          <td class="amount">{{line.amount | number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="!outstandingBalances.receivableLines.length">
          <td colspan="2">No receivable accounts matched.</td>
        </tr>
        <tr class="total">
          <td>Total Receivables</td>
          <td class="amount">{{outstandingBalances.totalReceivables | number:'1.2-2'}}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div>
      <h4>Accounts Payable</h4>
      <table class="statement-table">
        <thead>
        <tr>
          <th>Account</th>
          <th class="amount">Amount</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let line of outstandingBalances.payableLines">
          <td>{{line.accountCode}} {{line.accountName}}</td>
          <td class="amount">{{line.amount | number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="!outstandingBalances.payableLines.length">
          <td colspan="2">No payable accounts matched.</td>
        </tr>
        <tr class="total">
          <td>Total Payables</td>
          <td class="amount">{{outstandingBalances.totalPayables | number:'1.2-2'}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="report-card contract-report-panel">
  <div class="report-card-header">
    <h3>Contract Reporting</h3>
    <div class="actions">
      <button mat-stroked-button (click)="reloadReportConfig()" [disabled]="!selectedContractId || isReportConfigLoading">Reload Config</button>
      <button mat-raised-button color="primary" (click)="loadReport()" [disabled]="!selectedContractId">Run Contract Report</button>
    </div>
  </div>

  <div class="report-controls contract-controls">
    <mat-form-field appearance="fill">
      <mat-label>Contract</mat-label>
      <mat-select [(ngModel)]="selectedContractId" (selectionChange)="onSelectedContractChange()">
        <mat-option *ngFor="let contract of contracts" [value]="contract.id">
          {{contract.name || contract.id}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Date Range</mat-label>
      <mat-select [(ngModel)]="contractPreset" (selectionChange)="onContractRangePresetChange()">
        <mat-option *ngFor="let option of rangePresetOptions" [value]="option.value">
          {{option.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Period Start</mat-label>
      <input matInput type="date" [(ngModel)]="contractPeriodStart" (ngModelChange)="onContractCustomDateChanged()">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Period End</mat-label>
      <input matInput type="date" [(ngModel)]="contractPeriodEnd" (ngModelChange)="onContractCustomDateChanged()">
    </mat-form-field>
  </div>

  <div class="report-controls contract-controls" *ngIf="reportConfigControls.length">
    <ng-container *ngFor="let control of reportConfigControls">
      <mat-form-field appearance="fill" *ngIf="isTextControl(control)">
        <mat-label>{{control.label}}</mat-label>
        <input
          matInput
          [placeholder]="control.placeholder || ''"
          [(ngModel)]="reportControlValues[control.key]"
        >
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="isNumberControl(control)">
        <mat-label>{{control.label}}</mat-label>
        <input
          matInput
          type="number"
          [placeholder]="control.placeholder || ''"
          [(ngModel)]="reportControlValues[control.key]"
        >
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="isDateControl(control)">
        <mat-label>{{control.label}}</mat-label>
        <input
          matInput
          type="date"
          [(ngModel)]="reportControlValues[control.key]"
          (ngModelChange)="onReportControlDateChanged()"
        >
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="isSelectControl(control)">
        <mat-label>{{control.label}}</mat-label>
        <mat-select [(ngModel)]="reportControlValues[control.key]">
          <mat-option *ngFor="let option of control.options" [value]="option.value">
            {{option.label}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="dynamic-toggle" *ngIf="isBooleanControl(control)">
        <mat-label>{{control.label}}</mat-label>
        <mat-slide-toggle [(ngModel)]="reportControlValues[control.key]"></mat-slide-toggle>
      </div>
    </ng-container>
  </div>

  <p class="config-note" *ngIf="isReportConfigLoading">Loading report config...</p>
  <p class="config-note" *ngIf="!isReportConfigLoading && !reportConfigControls.length">
    This contract has no dynamic report controls configured.
  </p>

  <details *ngIf="reportConfig" class="raw-config">
    <summary>Raw Report Config</summary>
    <pre>{{reportConfig | json}}</pre>
  </details>
</div>

<div class="rollup-grid" *ngIf="report && renderedRollups.length">
  <div class="rollup-card" *ngFor="let rollup of renderedRollups">
    <span class="rollup-label">{{rollup.label}}</span>
    <strong class="rollup-value">{{rollup.displayValue}}</strong>
  </div>
</div>

<div class="report-card" *ngIf="report">
  <div class="report-card-header">
    <h3>Contract Summary</h3>
    <div class="contract-summary-context">
      <span><strong>Contract:</strong> {{report.contract.name || report.contract.id}}</span>
      <span><strong>Period:</strong> {{report.periodStart | date:'mediumDate'}} - {{report.periodEnd | date:'mediumDate'}}</span>
    </div>
  </div>

  <div class="statement-grid contract-summary-grid">
    <div>
      <h4>Movement Summary</h4>
      <table class="statement-table">
        <tbody>
        <tr>
          <td>Movement Count</td>
          <td class="amount">{{report.movementSummary.movementCount | number:'1.0-0'}}</td>
        </tr>
        <tr>
          <td>Gross In</td>
          <td class="amount">{{report.movementSummary.grossIn | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <td>Gross Out</td>
          <td class="amount">{{report.movementSummary.grossOut | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <td>Total Fees</td>
          <td class="amount">{{report.movementSummary.totalFees | number:'1.2-2'}}</td>
        </tr>
        <tr>
          <td>Net Delta</td>
          <td class="amount">{{report.movementSummary.netDelta | number:'1.2-2'}}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div>
      <h4>Settlements</h4>
      <table class="statement-table">
        <thead>
        <tr>
          <th>ID</th>
          <th>Status</th>
          <th class="amount">Total Payable</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let settlement of report.settlements">
          <td>{{settlement.id}}</td>
          <td>{{settlement.status}}</td>
          <td class="amount">{{settlement.totalPayable | number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="!report.settlements.length">
          <td colspan="3">No settlements in selected period.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div>
      <h4>Invoices</h4>
      <table class="statement-table">
        <thead>
        <tr>
          <th>Invoice #</th>
          <th>Status</th>
          <th class="amount">Amount</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let invoice of report.invoices">
          <td>{{invoice.invoiceNumber}}</td>
          <td>{{invoice.status}}</td>
          <td class="amount">{{invoice.amount | number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="!report.invoices.length">
          <td colspan="3">No invoices in selected period.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
